import { getLocalTranslation } from '../../utils/i18nKit';
export var getRecruitmentCoverTypeMap = function getRecruitmentCoverTypeMap() {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  return {
    "package": {
      value: 'package',
      label: $t('kit:quotes.combined_package')
    },
    pickAndChoose: {
      value: 'pick_choose',
      label: $t('kit:quotes.pick_and_choose')
    }
  };
};
export var getRecruitmentCoverTypeList = function getRecruitmentCoverTypeList() {
  return Object.values(getRecruitmentCoverTypeMap());
};